import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    permissionItem: {
      marginLeft: 40,
      paddingBlock: '2px',
      '& .MuiTypography-body1': {
        fontSize: 14,
      },
      '& .PrivateSwitchBase-root': {
        padding: 0,
      },
      '& .MuiIconButton-root': {
        padding: 0,
        marginRight: 5,
      },
    },
    pending: {
      background: 'rgba(239, 205, 51, .2)',
    },
  });
